/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Source_GoogleInputs */



/**
* | output |
* | --- |
* | "Google Calendar" |
*
* @param {Agenda_Source_GoogleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_source_google = /** @type {((inputs?: Agenda_Source_GoogleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Source_GoogleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Google Agenda")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Google Agenda")
	return /** @type {LocalizedString} */ ("Google Calendar")
});